import { ReactNode } from 'react';
import styles from './JuniorItem.module.css';

type Props = {
  imgSrc: string;
  imgAlt: string;
  title: ReactNode;
  quote: ReactNode;
};

export function JuniorItem({ imgSrc, imgAlt, title, quote }: Props) {
  return (
    <div className={styles.root}>
      <div className={styles.title}>{title}</div>
      <div className={styles.content}>
        <div className={styles.img}>
          <img src={imgSrc} alt={imgAlt} />
        </div>
        <div className={styles.quote}>{quote}</div>
      </div>
    </div>
  );
}
